const WIDGET_EXPERIMENT_KEY = 'widget_phase_experiment';
const WIDGET_EXPERIMENT_PHASE1_VALUE = 'phase1';
const WIDGET_EXPERIMENT_PHASE2_VALUE = 'phase2';
const WIDGET_EXPERIMENT_ABTEST_VALUE = 'abtestphase';
const FORCE_WIDGET_QUERY_PARAM = 'FORCE_WIDGET';
const FEATURE_PHASE2_LABEL_KEY = 'FEATURE_ACTIVATE_PHASE_2';

function randomIntFromInterval(min, max) { 
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function isStorageBlocked() {
    if (navigator && navigator.cookieEnabled) return false;

    // Check only once. Store the result in a storage var
    if ( isStorageBlocked.value !== undefined ) {
        return isStorageBlocked.value;
    }

    // Create a cookie and check if it has been written.
    document.cookie = "feverwidgettest=1";
    const blocked = !document.cookie.indexOf("feverwidgettest=") !== -1;
    // Delete cookie
    document.cookie = "feverwidgettest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
    // Make the value static
    isStorageBlocked.value = blocked;
    return isStorageBlocked.value;
}

function calculateFallbackPhase(phase) {
    switch (phase) {
        case WIDGET_EXPERIMENT_PHASE2_VALUE:
            return WIDGET_EXPERIMENT_PHASE2_VALUE;
        case WIDGET_EXPERIMENT_PHASE1_VALUE:
        default:
            return WIDGET_EXPERIMENT_PHASE1_VALUE;
    }
}

function readConfiguredWidgetPhase(phase, fallbackPhase) {
    switch (phase) {
        case WIDGET_EXPERIMENT_ABTEST_VALUE:
            if (isStorageBlocked()) {
                console.warn('Session storage is blocked. Using the default widget phase.');
                return fallbackPhase;
            }
            return (randomIntFromInterval(0, 1) === 1)
              ? WIDGET_EXPERIMENT_PHASE1_VALUE
              : WIDGET_EXPERIMENT_PHASE2_VALUE;
        case WIDGET_EXPERIMENT_PHASE2_VALUE:
            return WIDGET_EXPERIMENT_PHASE2_VALUE;
        case WIDGET_EXPERIMENT_PHASE1_VALUE:
        default:
            return WIDGET_EXPERIMENT_PHASE1_VALUE;
    }
}

function overloadStorageWidgetPhase(readPhase) {
    if (isStorageBlocked()) {
        console.warn('Unreadable stored widget phase.');
        return readPhase;
    }
    
    const storedPhase = sessionStorage.getItem(WIDGET_EXPERIMENT_KEY);
    switch (storedPhase) {
        case WIDGET_EXPERIMENT_PHASE1_VALUE:
            return WIDGET_EXPERIMENT_PHASE1_VALUE;
        case WIDGET_EXPERIMENT_PHASE2_VALUE:
            return WIDGET_EXPERIMENT_PHASE2_VALUE;
        default:
            return readPhase;
    }
}

function overloadQueryParamsWidgetPhase(storedPhase) {
    const params = new URLSearchParams(location.search);
    const forcedPhase = params.has(FORCE_WIDGET_QUERY_PARAM)
        ? params.get(FORCE_WIDGET_QUERY_PARAM)
        : null;
    switch (forcedPhase) {
        case WIDGET_EXPERIMENT_PHASE1_VALUE:
            return WIDGET_EXPERIMENT_PHASE1_VALUE;
        case WIDGET_EXPERIMENT_PHASE2_VALUE:
            return WIDGET_EXPERIMENT_PHASE2_VALUE;
        default:
            return storedPhase;
    }
}

function calculatePhase(configuredPhase, fallbackPhase) {
    let phase = readConfiguredWidgetPhase(configuredPhase, fallbackPhase);
    if(configuredPhase === WIDGET_EXPERIMENT_ABTEST_VALUE) {
        phase = overloadStorageWidgetPhase(phase);
    }
    return overloadQueryParamsWidgetPhase(phase);
}

function storeWidgetPhase(phase) {
    if (isStorageBlocked()) {
        console.warn('Widget phase storage is blocked');
        return;
    }

    sessionStorage.setItem(WIDGET_EXPERIMENT_KEY, phase);
}


function buildWidgetFeatures (featuresText, calculatedPhase) {
    let featuresParsed = {};
    if (
        featuresText !== undefined
        && featuresText !== null
        && typeof(featuresText) === 'string'
        && featuresText.length > 0
    ) {
        featuresParsed = featuresText.split(',').reduce(
            function(features, feature) {
                features[feature] = true;
                return features;
            }, {}
        );
    }

    featuresParsed[FEATURE_PHASE2_LABEL_KEY] = calculatedPhase === WIDGET_EXPERIMENT_PHASE2_VALUE;

    return featuresParsed;
}

function calculateUtms (defaultUtms) {
    const params = new URLSearchParams(location.search);
    // utm term cannot be overwritten.
    return {
        source: params.get('utm_source') || defaultUtms.source || null,
        medium: params.get('utm_medium') || defaultUtms.medium || null,
        campaign: params.get('utm_campaign') || defaultUtms.campaign || null,
        term: defaultUtms.term || null,
    }
}

const widget = document.getElementById('widget');
const planId = widget.getAttribute('data-plan-id');
const theme = widget.getAttribute('data-theme');
const language = widget.getAttribute('data-lang');
const redirectUri = widget.getAttribute('data-redirect-url');
const width = widget.getAttribute('data-width');
const height = widget.getAttribute('data-height');
const url = widget.getAttribute('data-host');
const utmSource = widget.getAttribute('data-utm-source');
const utmMedium = widget.getAttribute('data-utm-medium');
const utmCampaign = widget.getAttribute('data-utm-campaign');
const utmPhase1 = widget.getAttribute('data-utm-term-phase1');
const utmPhase2 = widget.getAttribute('data-utm-term-phase2');
const utmHidden = widget.getAttribute('data-utm-term-hidden');
const widgetHidden = widget.getAttribute('data-widget-hidden');
const fallbackPhase = calculateFallbackPhase(widget.getAttribute('data-fallback-phase'));
const phase = calculatePhase(widget.getAttribute('data-phase'), fallbackPhase);

storeWidgetPhase(phase);
const featureFlags = buildWidgetFeatures(widget.getAttribute('data-features'), phase);

const utms = calculateUtms({
    source: utmSource,
    medium: utmMedium,
    campaign: utmCampaign,
    term: widgetHidden !== null ? utmHidden : phase === WIDGET_EXPERIMENT_PHASE1_VALUE ? utmPhase1 : utmPhase2
});

initializeWidget(widget, planId, {
    theme,
    language,
    redirectUri,
    width,
    height,
    url,
    utms,
    featureFlags,
});
